import { Link } from "react-router-dom";

const IMPACT = [
  { stat: "595",    label: "Reorder items identified",        project: "Inventory Stock Reorder System", icon: "📦" },
  { stat: "2,000+", label: "Inventory lines analyzed",        project: "Inventory Stock Reorder System", icon: "📊" },
  { stat: "5 Yrs",  label: "Maritime accident data analyzed", project: "OceanGuard Analytics",           icon: "🚢" },
  { stat: "9",      label: "Multi-tenant database tables",    project: "MartSense SaaS",                icon: "🗄️" },
  { stat: "4",      label: "Live forex pairs monitored",      project: "Forex Alert System",             icon: "📈" },
  { stat: "4+",     label: "Live software products built",    project: "StackSense Technologies",        icon: "⚡" },
];

const PRODUCTS = [
  {
    icon: "📦", iconImg: "/martsense-logo.png", name: "MartSense", nameEl: (<><span style={{ color: "#2ec4b6" }}>Mart</span><span style={{ color: "#f6a809" }}>Sense</span></>),
    tagline: "Inventory & Sales for African SMEs",
    desc: "Real-time stock alerts, sales analytics, Paystack subscriptions and CSV bulk import — built specifically for Nigerian small businesses.",
    badge: "Live", badgeColor: "#2ecc71", badgeBg: "#0a2a16",
    link: "https://martsense.com.ng", linkText: "Launch App →", featured: true,
    mockup: "/martsense-mockup.webp",
  },
  {
    icon: "🌊", name: "OceanGuard Analytics",
    tagline: "Maritime Accident Prevention Platform",
    desc: "Five years of MAIB accident data transformed into interactive dashboards and safety insights for fleet operators and maritime safety officers.",
    badge: "Live", badgeColor: "#2ecc71", badgeBg: "#0a2a16",
    link: "https://oceanguard-analytics-egg7zqwswgdmzrnybexkbj.streamlit.app/", linkText: "View Platform →", featured: false,
    mockup: "/oceanguard-mockup.webp",
  },
  {
    icon: "🚢", name: "VesselStock Pro", iconImg: "/vesselstock-logo.png",
    tagline: "Offshore & Maritime Inventory System",
    desc: "A comprehensive inventory management system purpose-built for vessels, FPSOs, rigs and offshore platforms. Perpetual license model for maritime operators.",
    badge: "Coming Soon", badgeColor: "#c9a84c", badgeBg: "#1c1a0a",
    link: null, linkText: "Coming Soon", featured: false,
    mockup: "/vesselstock-mockup.webp", 
  },
];
const SERVICES_PREVIEW = [
  { icon: "🤖", title: "Data Automation",        slug: "data-automation" },
  { icon: "🗄️", title: "Database Management",    slug: "database-management" },
  { icon: "📊", title: "Data Analytics",         slug: "data-analytics" },
  { icon: "🧠", title: "Machine Learning",        slug: "machine-learning" },
  { icon: "📦", title: "Custom Software",        slug: "custom-software" },
  { icon: "🚢", title: "Maritime Technology",    slug: "maritime-technology" },
];

export default function Home() {
  return (
    <>
      {/* ── Hero ── */}
      <section style={s.hero}>
        <img
  src="/hero-bg.webp"
  alt=""
  aria-hidden="true"
  style={{
    position: "absolute", inset: 0,
    width: "100%", height: "100%",
    objectFit: "cover", objectPosition: "center",
    opacity: 0.18,
    zIndex: 0,
    pointerEvents: "none",
  }}
/>
<div style={s.heroGrid} />
        <div style={s.heroGrid} />
        <div style={s.heroGlow} />

        <div style={s.heroContent}>
          <div style={s.heroBadge}>
            <span style={s.heroBadgeDot} />
            Lagos, Nigeria — Building for Africa and Beyond
          </div>

          <h1 style={s.heroTitle}>
            Intelligent Software
            <br />
            <span style={s.heroAccent}>for Real Business</span>
          </h1>

          <p style={s.heroSub}>
            StackSense Technologies builds data-driven software products for African SMEs and
            global maritime industries — engineered by someone who has worked the engine rooms
            and the dashboards.
          </p>

          <div style={s.heroButtons}>
            <a href="https://wa.me/2348077460114" target="_blank" rel="noreferrer" style={s.heroBtnPrimary}>
              💬 Get a Free Quote
            </a>
            <Link to="/products" style={s.heroBtnSecondary}>
              Explore Products
            </Link>
          </div>

          <div style={s.heroStats}>
            {[
              { value: "4+",  label: "Products Built" },
              { value: "18+", label: "Years Domain Experience" },
              { value: "50+", label: "Projects Delivered" },
            ].map((stat) => (
              <div key={stat.label} style={s.heroStat}>
                <span style={s.heroStatValue}>{stat.value}</span>
                <span style={s.heroStatLabel}>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Scroll down chevron */}
        <div style={{
          position: "absolute", bottom: "32px", left: "50%",
          transform: "translateX(-50%)",
          display: "flex", flexDirection: "column",
          alignItems: "center", gap: "4px",
          animation: "fadeInUp 1.5s ease 0.8s both",
        }}>
          <span style={{ fontSize: "11px", color: "#567878", letterSpacing: "1px", textTransform: "uppercase" }}>Scroll</span>
          <span style={{
            fontSize: "24px", color: "#2ec4b6",
            animation: "pulse 2s ease-in-out infinite",
            lineHeight: 1,
          }}>⌄</span>
        </div>
      </section>
      
      {/* ── Mission Blurb ── */}
      <section style={s.missionSection}>
        <div style={s.inner}>
          {/* mission-grid class handles responsive stacking in App.css */}
          <div className="mission-grid">
            <div style={s.missionLeft}>
              <div style={s.sectionTag}>Our Mission</div>
              <h2 style={s.missionTitle}>
                Where Engineering Precision
                <br />Meets Data Intelligence
              </h2>
            </div>
            <div style={s.missionRight}>
              <p style={s.missionText}>
                Founded by a Marine Engineer turned Data Scientist, StackSense Technologies brings a rare
                combination — nearly two decades of hands-on industry expertise fused with modern software
                development and machine learning. We don't just build software. We solve the problems we
                understand deeply.
              </p>
              <Link to="/about" style={s.missionLink}>Learn about us →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── Products Showcase ── */}
      <section style={s.productsSection}>
        <div style={s.inner}>
          <div style={s.sectionTag}>Our Products</div>
          <h2 style={s.sectionTitle}>
            Intelligent Software for
            <br /><span style={s.accent}>Real Business Problems</span>
          </h2>

          <div className="home-products-grid">
            {PRODUCTS.map((p) => (
              <div
                key={p.name}
                style={{
                  ...s.productCard,
                  border: p.featured ? "1px solid rgba(46,196,182,0.4)" : "1px solid #182828",
                  background: p.featured ? "linear-gradient(145deg, #0c1e1e, #0c1515)" : "#0c1515",
                }}
                className="card-hover"
              >
                <div style={s.productCardTop}>
                  {p.iconImg
                  ? <img src={p.iconImg} alt={p.name} style={{ width: "64px", height: "64px", objectFit: "contain", background: "rgba(255,255,255,0.06)", borderRadius: "10px", padding: "6px" }} />
                  : <span style={s.productIcon}>{p.icon}</span>
                }
                  <span style={{ background: p.badgeBg, color: p.badgeColor, ...s.productBadge }}>
                    {p.badge}
                  </span>
                </div>
                <h3 style={s.productName}>{p.nameEl || p.name}</h3>
                <p style={s.productTagline}>{p.tagline}</p>
                <p style={s.productDesc}>{p.desc}</p>
                {p.mockup && (
                  <img
                    src={p.mockup}
                    alt={`${p.name} screenshot`}
                    style={{
                      width: "100%", borderRadius: "10px",
                      border: "1px solid #182828",
                      objectFit: "cover", height: "160px",
                    }}
                  />
                )}
                {p.link ? (
                  <a href={p.link} target="_blank" rel="noreferrer" style={s.productBtn}>
                    {p.linkText}
                  </a>
                ) : (
                  <span style={s.productBtnDisabled}>{p.linkText}</span>
                )}
              </div>
            ))}
          </div>

          <div style={{ textAlign: "center", marginTop: "36px" }}>
            <Link to="/products" style={s.viewAllLink}>View all products →</Link>
          </div>
        </div>
      </section>

      {/* ── Services Teaser ── */}
      <section style={s.servicesSection}>
        <div style={s.inner}>
          <div style={{
            display: "flex", justifyContent: "space-between",
            alignItems: "flex-end", flexWrap: "wrap", gap: "24px", marginBottom: "40px",
          }}>
            <div>
              <div style={s.sectionTag}>Our Services</div>
              <h2 style={{ ...s.sectionTitle, marginBottom: 0 }}>
                What We Build
                <br /><span style={s.accent}>For Your Business</span>
              </h2>
            </div>
            <Link to="/services" style={s.viewAllLink}>View all services →</Link>
          </div>

          <div className="home-services-grid">
            {SERVICES_PREVIEW.map((svc) => (
              <Link
                key={svc.slug}
                to={`/services/${svc.slug}`}
                style={s.serviceMiniCard}
                className="service-mini-hover"
              >
                <span style={s.serviceMiniIcon}>{svc.icon}</span>
                <span style={s.serviceMiniTitle}>{svc.title}</span>
                <span style={s.serviceMiniArrow}>→</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── Impact Numbers ── */}
      <section style={s.impactSection}>
        <div style={s.inner}>
          <div style={s.sectionTag}>Proven Impact</div>
          <h2 style={s.sectionTitle}>
            Real Work.
            <br /><span style={s.accent}>Real Numbers.</span>
          </h2>
          <p style={s.impactSubtitle}>
            Every number below comes from an actual project we delivered. No estimates. No projections.
          </p>

          <div style={s.impactGrid}>
            {IMPACT.map((r) => (
              <div key={r.label} style={s.impactCard} className="card-hover">
                <span style={s.impactIcon}>{r.icon}</span>
                <p style={s.impactStat}>{r.stat}</p>
                <p style={s.impactLabel}>{r.label}</p>
                <p style={s.impactProject}>{r.project}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={s.ctaSection}>
        <div style={s.inner}>
          <div style={s.ctaBox}>
            <p style={s.ctaEyebrow}>🚀 Early Access</p>
            <h2 style={s.ctaTitle}>Be Among Our First Clients</h2>
            <p style={s.ctaText}>
              MartSense is live and accepting its first business subscribers. Early adopters get
              direct access to the founder and priority support — your feedback shapes the product.
            </p>
            <div style={s.ctaButtons}>
              <a href="https://wa.me/2348077460114" target="_blank" rel="noreferrer" style={s.ctaBtnPrimary}>
                💬 Talk to the Founder
              </a>
              <a href="https://martsense.com.ng" target="_blank" rel="noreferrer" style={s.ctaBtnSecondary}>
                Try MartSense Free
              </a>
            </div>
          </div>

          {/* Trust bar */}
          <div style={s.trustBar}>
            {[
              { icon: "🏢", label: "Lagos, Nigeria" },
              { icon: "🔒", label: "Secure & Reliable" },
              { icon: "📱", label: "Mobile First" },
              { icon: "🌍", label: "Built for Africa" },
              { icon: "⚡", label: "Fast Delivery" },
              { icon: "🚢", label: "Maritime Expertise" },
            ].map((item) => (
              <div key={item.label} style={s.trustItem}>
                <span style={s.trustIcon}>{item.icon}</span>
                <span style={s.trustLabel}>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

/* ─── Styles ─────────────────────────────────────────── */
const s = {
  inner: { maxWidth: "1200px", margin: "0 auto" },

  sectionTag: {
    display: "inline-block",
    background: "rgba(46,196,182,0.08)", border: "1px solid rgba(46,196,182,0.18)",
    borderRadius: "20px", padding: "4px 14px",
    fontSize: "11px", color: "#2ec4b6", marginBottom: "20px",
    textTransform: "uppercase", letterSpacing: "1.2px", fontWeight: 600,
  },
  sectionTitle: {
    fontSize: "clamp(28px, 5vw, 48px)",
    fontWeight: 800, color: "#e8f5f5",
    marginBottom: "48px", lineHeight: "1.12",
    letterSpacing: "-1.5px",
    fontFamily: "'Space Grotesk', 'DM Sans', sans-serif",
  },
  accent: { color: "#2ec4b6" },

  /* Hero */
  hero: {
    minHeight: "100vh",
    display: "flex", flexDirection: "column",
    justifyContent: "center", alignItems: "center",
    position: "relative", overflow: "hidden",
    padding: "100px 24px 80px",
    background: "#070d0d",
  },
  heroGrid: {
    position: "absolute", inset: 0,
    backgroundImage: `
      linear-gradient(rgba(46,196,182,0.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(46,196,182,0.025) 1px, transparent 1px)
    `,
    backgroundSize: "64px 64px",
    pointerEvents: "none",
  },
  heroGlow: {
    position: "absolute", top: "15%", left: "50%",
    transform: "translateX(-50%)",
    width: "700px", height: "500px",
    background: "radial-gradient(ellipse, rgba(46,196,182,0.07) 0%, transparent 70%)",
    pointerEvents: "none",
    animation: "heroPulse 6s ease-in-out infinite",
  },
  heroContent: { position: "relative", maxWidth: "820px", textAlign: "center", zIndex: 1 },
  heroBadge: {
    display: "inline-flex", alignItems: "center", gap: "8px",
    background: "rgba(46,196,182,0.08)", border: "1px solid rgba(46,196,182,0.18)",
    borderRadius: "20px", padding: "6px 18px",
    fontSize: "13px", color: "#2ec4b6", marginBottom: "32px",
  },
  heroBadgeDot: {
    width: "7px", height: "7px", borderRadius: "50%",
    background: "#2ec4b6", animation: "pulse 2s infinite", flexShrink: 0,
  },
  heroTitle: {
    fontSize: "clamp(36px, 7.5vw, 82px)",
    fontWeight: 800, lineHeight: "1.08",
    color: "#e8f5f5", marginBottom: "24px",
    letterSpacing: "-2.5px",
    fontFamily: "'Space Grotesk', 'DM Sans', sans-serif",
  },
  heroAccent:    { color: "#2ec4b6" },
  heroSub: {
    fontSize: "clamp(15px, 2.5vw, 18px)",
    color: "#7a9e9e", lineHeight: "1.75",
    maxWidth: "580px", margin: "0 auto 40px", fontWeight: 400,
  },
  heroButtons: {
    display: "flex", gap: "14px",
    justifyContent: "center", flexWrap: "wrap", marginBottom: "64px",
  },
  heroBtnPrimary: {
    background: "#2ec4b6", color: "#040b0b",
    border: "none", borderRadius: "10px",
    padding: "16px 32px", fontSize: "15px", fontWeight: 700,
    cursor: "pointer", fontFamily: "inherit", textDecoration: "none",
    display: "inline-block",
  },
  heroBtnSecondary: {
    background: "none", color: "#2ec4b6",
    border: "1px solid rgba(46,196,182,0.3)", borderRadius: "10px",
    padding: "16px 32px", fontSize: "15px", fontWeight: 600,
    cursor: "pointer", fontFamily: "inherit", textDecoration: "none",
    display: "inline-block",
  },
  heroStats: {
    display: "flex", gap: "48px",
    justifyContent: "center", flexWrap: "wrap",
    borderTop: "1px solid #182828", paddingTop: "40px",
  },
  heroStat:      { display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" },
  heroStatValue: { fontSize: "34px", fontWeight: 800, color: "#2ec4b6", letterSpacing: "-1px", fontFamily: "'Space Grotesk', sans-serif" },
  heroStatLabel: { fontSize: "12px", color: "#567878", textTransform: "uppercase", letterSpacing: "0.5px" },

  /* Mission — layout handled by .mission-grid CSS class */
  missionSection: { padding: "80px 24px", background: "#040a0a", borderTop: "1px solid #182828" },
  missionLeft:    {},
  missionTitle: {
    fontSize: "clamp(22px, 4vw, 40px)",
    fontWeight: 800, color: "#e8f5f5",
    lineHeight: "1.15", letterSpacing: "-1px",
    fontFamily: "'Space Grotesk', 'DM Sans', sans-serif",
  },
  missionRight: { display: "flex", flexDirection: "column", gap: "20px" },
  missionText:  { fontSize: "17px", color: "#7a9e9e", lineHeight: "1.85" },
  missionLink:  { color: "#2ec4b6", fontWeight: 700, fontSize: "15px", textDecoration: "none" },

  /* Products */
  productsSection: { padding: "80px 24px", background: "#070d0d" },
  productCard: {
    borderRadius: "18px", padding: "32px",
    display: "flex", flexDirection: "column", gap: "12px",
  },
  productCardTop: { display: "flex", justifyContent: "space-between", alignItems: "center" },
  productIcon:   { fontSize: "32px" },
  productBadge:  { borderRadius: "20px", padding: "4px 12px", fontSize: "11px", fontWeight: 700 },
  productName: {
    fontSize: "22px", fontWeight: 800, color: "#e8f5f5",
    letterSpacing: "-0.5px",
    fontFamily: "'Space Grotesk', 'DM Sans', sans-serif",
  },
  productTagline: { fontSize: "12px", color: "#2ec4b6", fontWeight: 600 },
  productDesc:    { fontSize: "14px", color: "#7a9e9e", lineHeight: "1.7", flex: 1 },
  productBtn: {
    display: "inline-block", background: "#2ec4b6",
    color: "#040b0b", borderRadius: "10px",
    padding: "12px 22px", fontSize: "14px",
    fontWeight: 700, textDecoration: "none", marginTop: "6px",
  },
  productBtnDisabled: {
    display: "inline-block", background: "none",
    border: "1px solid #182828", color: "#567878",
    borderRadius: "10px", padding: "12px 22px",
    fontSize: "14px", fontWeight: 600, marginTop: "6px",
  },
  viewAllLink: { color: "#2ec4b6", fontWeight: 700, fontSize: "14px", textDecoration: "none" },

  /* Services teaser */
  servicesSection: { padding: "80px 24px", background: "#040a0a" },
  serviceMiniCard: {
    background: "#0c1515", border: "1px solid #182828",
    borderRadius: "12px", padding: "20px 22px",
    display: "flex", alignItems: "center", gap: "12px",
    textDecoration: "none", cursor: "pointer",
  },
  serviceMiniIcon:  { fontSize: "24px", flexShrink: 0 },
  serviceMiniTitle: { fontSize: "14px", color: "#e8f5f5", fontWeight: 600, flex: 1, fontFamily: "'Space Grotesk', sans-serif" },
  serviceMiniArrow: { fontSize: "14px", color: "#2ec4b6", fontWeight: 700 },

  /* Impact */
  impactSection:  { padding: "80px 24px", background: "#070d0d" },
  impactSubtitle: { fontSize: "16px", color: "#7a9e9e", marginBottom: "48px", marginTop: "-28px" },
  impactGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "18px",
  },
  impactCard: {
    background: "#0c1515", border: "1px solid #182828",
    borderRadius: "14px", padding: "26px",
    display: "flex", flexDirection: "column", gap: "8px",
  },
  impactIcon:    { fontSize: "26px" },
  impactStat: {
    fontSize: "34px", fontWeight: 800, color: "#2ec4b6",
    letterSpacing: "-1px",
    fontFamily: "'Space Grotesk', 'DM Sans', sans-serif",
  },
  impactLabel:   { fontSize: "14px", fontWeight: 600, color: "#e8f5f5" },
  impactProject: { fontSize: "12px", color: "#567878", fontStyle: "italic" },

  /* CTA */
  ctaSection: { padding: "80px 24px", background: "#040a0a" },
  ctaBox: {
    background: "linear-gradient(135deg, #0a1e1e, #0c1515)",
    border: "1px solid rgba(46,196,182,0.2)",
    borderRadius: "20px", padding: "56px 32px",
    textAlign: "center", marginBottom: "56px",
  },
  ctaEyebrow: { fontSize: "24px", marginBottom: "12px" },
  ctaTitle: {
    fontSize: "clamp(24px, 4vw, 42px)",
    fontWeight: 800, color: "#e8f5f5",
    marginBottom: "16px", letterSpacing: "-1px",
    fontFamily: "'Space Grotesk', 'DM Sans', sans-serif",
  },
  ctaText: {
    fontSize: "17px", color: "#7a9e9e",
    lineHeight: "1.75", maxWidth: "540px",
    margin: "0 auto 32px",
  },
  ctaButtons: { display: "flex", gap: "14px", justifyContent: "center", flexWrap: "wrap" },
  ctaBtnPrimary: {
    display: "inline-block", background: "#2ec4b6",
    color: "#040b0b", borderRadius: "10px",
    padding: "15px 32px", fontSize: "15px",
    fontWeight: 700, textDecoration: "none",
  },
  ctaBtnSecondary: {
    display: "inline-block", background: "none",
    border: "1px solid rgba(46,196,182,0.3)",
    color: "#2ec4b6", borderRadius: "10px",
    padding: "15px 32px", fontSize: "15px",
    fontWeight: 600, textDecoration: "none",
  },

  /* Trust bar */
  trustBar: {
    display: "flex", justifyContent: "center",
    gap: "28px", flexWrap: "wrap",
    borderTop: "1px solid #182828", paddingTop: "36px",
  },
  trustItem:  { display: "flex", alignItems: "center", gap: "8px" },
  trustIcon:  { fontSize: "16px" },
  trustLabel: { fontSize: "12px", color: "#567878", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" },
};
